import React, { memo } from 'react'

import { Icon, LayoutSidebar } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

const iconSize = {
  height: '20px',
  width: '20px',
}

function Header({ isOpen, handleToggleSidebar }) {
  const t = useTranslation()

  return (
    <div
      role="button"
      tabIndex={0}
      className="sidebar__header"
      onClick={handleToggleSidebar}
    >
      {!isOpen && (
        <span className="sidebar__header-icon">
          <Icon
            svgComponent={LayoutSidebar}
            color="dark"
            size={iconSize}
            notSpaced
          />
        </span>
      )}
      {isOpen && (
        <>
          <span className="sidebar__header-title">{t('sidebar.header.title')}</span>
          <Icon
            className="sidebar__header-trail"
            svgComponent={LayoutSidebar}
            color="dark"
            size={iconSize}
            notSpaced
          />
        </>
      )}
    </div>
  )
}

Header.propTypes = {
  isOpen: bool.isRequired,
  handleToggleSidebar: func.isRequired,
}

export default memo(Header)
